import { Typography, Grid } from "@mui/material";

const CustomHeader = ({ headerText }) => {
    return (
        <Grid size={{xs: 12}}>
            <Typography variant="h6" sx={{fontWeight: 700}}>{headerText}</Typography>
        </Grid>
    );
};

export default CustomHeader;
